import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import ClientTopBar from './ClientTopBar';
import SaldoWidget from '../ui/SaldoWidget';

interface ResponsiveClientLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  className?: string;
}

interface ButtonLinkProps {
  to: string;
  className: string;
  children: React.ReactNode;
  state?: Record<string, unknown>;
}

const ButtonLink: React.FC<ButtonLinkProps> = ({ to, className, children, state }) => (
  <Button asChild size="lg" className={`${className} w-full`}>
    <Link to={to} state={state}>
      {children}
    </Link>
  </Button>
);

const ResponsiveClientLayout: React.FC<ResponsiveClientLayoutProps> = ({ 
  children, 
  title = "Bem-vindo de volta!", 
  subtitle = "Acompanhe suas reservas e gerencie seus créditos",
  className = ""
}) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="bg-white shadow-sm border-b">
        <div className="flex items-center justify-between px-4 md:px-6 py-3 gap-4">
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="Vita Sana Logo" className="h-12 w-auto" />
            <h1 className="text-xl font-bold text-gray-900">Vita Sana</h1>
          </div>
          <div className="flex items-center gap-3">
            <SaldoWidget size="small" showLink={false} hideIcon className="w-32" />
            <ClientTopBar />
          </div>
        </div>
      </div>

      <div className="bg-white border-b">
        <div className="px-4 md:px-6 py-3">
          <div className="flex flex-col lg:flex-row gap-3">
            <ButtonLink to="/client/calendar" className="bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600">
              Agendar a Sala
            </ButtonLink>
            <ButtonLink to="/client/reservations" className="bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600">
              Minhas Reservas
            </ButtonLink>
            <ButtonLink to="/client/creditos" className="bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600">
              Minha Carteira
            </ButtonLink>
            <ButtonLink to="/client/creditos" state={{ openPurchase: true }} className="bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600">
              Comprar Créditos
            </ButtonLink>
            <ButtonLink to="/client/creditos" state={{ openRefund: true }} className="bg-gradient-to-r from-rose-500 to-red-500 hover:from-rose-600 hover:to-red-600">
              Solicitar Reembolso
            </ButtonLink>
            <ButtonLink to="/client/profile" className="bg-gradient-to-r from-slate-500 to-gray-600 hover:from-slate-600 hover:to-gray-700">
              Perfil
            </ButtonLink>
          </div>
        </div>
      </div>

      <div className="flex-1 p-4 md:p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">{title}</h1>
          <p className="text-gray-600">{subtitle}</p>
        </div>
        <div className={className}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default ResponsiveClientLayout; 
